import { useContext, useEffect, useRef } from "react";
import { ContextNav, ContextDashboard } from "../../../context";
import NavData from "./NavData";
import { Link } from 'react-router-dom'
import { useNavigate } from "react-router-dom";

export const Nav = () => {
    const navigate = useNavigate()
    const CtxNav = useContext(ContextNav)
    const CtxDash = useContext(ContextDashboard)
    const navRef: any = useRef()
    const bgNavRef: any = useRef()


    const Logout = () => {
        localStorage.clear();
        navigate('/');
    }

    const changeActiveItem = (index: number) => {
        let activeItem = { ...CtxNav.activeMenuItem };
        activeItem.item = index;
        activeItem.subItem = 0;
        CtxNav.setActiveMenuItem(activeItem)
    }

    useEffect(() => {
        window.addEventListener('click', function (e: any) {
            if (bgNavRef?.current?.contains(e.target)!) {
                if (!navRef?.current?.contains(e.target)) {
                    CtxNav.setDisplayNavMobile(false)
                }
            }
        });
    }, [])

    useEffect(() => {
        window.addEventListener('resize', () => {
            if (window.innerWidth > 768) {
                CtxNav.setDisplayNavMobile(false)
            }
        })
    }, [])

    return (
        <>
            <div ref={bgNavRef} className={` right-0 bottom-0 top-0  bg-[#0000004d] backdrop-blur-[4px] fixed z-40 transition-all ${CtxNav.displayNavMobile ? 'opacity-100 visible left-0 w-full min-h-screen' : 'opacity-0 invisible left-full w-0  transition-all'}`}></div>
            <div ref={navRef} className={`w-[270px] bg-dayan-gray-50 min-h-screen  flex flex-col items-center pl-3 pt-[10px] md:pt-[20px] transition-all z-50 fixed md:relative right-[-300px]  md:right-0 delay-200 `} style={{ right: CtxNav.displayNavMobile && '0' }}>
                <Link to='/'>
                    <img src="/assetes/logo/logo.png" alt="logo" className=" w-[100px] md:w-[140px]  mt-[0] md:mt-[20px]" />
                </Link>
                <div className=" w-full md:hidden flex items-center justify-center mt-[20px]">
                    <Link to='/p/ticket'>
                        <div className=" w-[30px] h-[30px] mx-1 rounded cursor-pointer bg-dayan-gray-80 flex justify-center items-center text-white text-[11px]">
                            <img src='/assetes/svg/message.svg' className=" w-[15px]" />
                        </div>
                    </Link>
                    <div className=" w-[70px] h-[30px] mx-1 rounded cursor-pointer bg-dayan-gray-200 flex justify-center items-center text-white text-[11px]">باقی {CtxDash.dashboard?.plan_remaining_days} روز</div>
                    <Link to={'/p/plan'}>
                        <div className=" w-[70px] h-[30px] mx-1 rounded cursor-pointer bg-dayan-orange-50 flex justify-center items-center text-white text-[11px]">تمدید / ارتقا</div>
                    </Link>
                </div>
                <div className="w-full flex flex-col mt-[10px] md:mt-[20px] pr-[10px] md:pr-[20px]">
                    {NavData.map((item: any, index: number) =>
                        <div key={index} className={`w-full overflow-hidden rounded-[10px] ${CtxNav.activeMenuItem.item == index && 'bg-dayan-gray-80'}`} >
                            <Link to={item.link ? item.link : item.submenu[0].link}>
                                <div onClick={() => changeActiveItem(index)} className={`w-full h-[50px] px-[10px] flex items-center cursor-pointer rounded-lg  ${CtxNav.activeMenuItem.item == index && 'bg-dayan-orange-50'}`}>
                                    <svg x="0px" y="0px" viewBox={item.viewBox} className={`  h-[18px]  ${CtxNav.activeMenuItem.item == index ? 'fill-white' : 'fill-dayan-gray-100'} `}>
                                        <use xlinkHref={item.icon} />
                                    </svg>
                                    <span className={`text-sm mr-3 ${CtxNav.activeMenuItem.item == index ? 'text-white' : 'text-dayan-gray-200'}`}>{item.name}</span>
                                </div>
                            </Link>
                            <div className={` w-full bg-dayan-gray-80 transition-all flex flex-col overflow-hidden ${item.isSubmenu == true && CtxNav.activeMenuItem.item == index ? 'h-fit transition-all py-[10px]' : 'h-0 transition-all py-0'}`}>
                                {item.submenu && item.submenu.map((value: any, indexVal: any) =>
                                    <Link key={indexVal} to={value.link}>
                                        <div key={indexVal} className="w-full h-[40px] flex items-center px-[30px] text-sm text-white flex items-center">
                                            {CtxNav.activeMenuItem.subItem == indexVal &&
                                                <span className="flex w-[10px] h-[10px] rounded-full bg-white" />
                                            }
                                            <span className="mr-[15px]">{value.name}</span>
                                        </div>
                                    </Link>
                                )}
                            </div>
                        </div>
                    )}
                    <div className={`w-full overflow-hidden rounded-[10px] `} >
                        <div onClick={Logout} className={`w-full h-[50px] px-[10px] flex items-center cursor-pointer rounded-lg `}>
                            <svg x="0px" y="0px" viewBox={'0 0 96.943 96.943'} className={`  h-4 fill-dayan-gray-100 `}>
                                <use xlinkHref="/assetes/svg/logout.svg#logout" />
                            </svg>
                            <span className={`text-sm mr-3 text-dayan-gray-200`}>خروج</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}